import Modal from "../Modal/Modal";
import React from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";
import { Divider } from "antd";
import FormButton from "../../components/FormCustom2/Button";
const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalConfirmDelete = (props) => {
  const { item } = props;
  const { T, loading } = useApp();
  const onClose = () => {
    props.onClose();
  };
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2 width="600px" onClose={onClose}>
        <ContentWaper>
          <div className="text-black text-center font-medium text-[20px] lg:text-[30px] tracking-[-0.96px]">
          {T(props?.title)}
          </div>
          <div className="mt-[10px] lg:mt-[10px]">
            <div>
              <div className="mt-[15px] lg:mt-[20px] py-6 flex justify-center text-center items-center text-[14px] text-black text-base leading-[26px]">
                {T("Are you sure you want to delete the address {wallet_name}?").replace("{wallet_name}", `<${item?.name}>`)}
              </div>
              <Divider className="my-[32px] hidden md:block" />
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap md:flex-nowrap justify-center items-center gap-[20px]">
                <FormButton
                  className={"black2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  {props?.btnCancelText ? T(props?.btnCancelText) : T("Cancel")}
                </FormButton>
                <FormButton
                  className={"primary2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    props.onSubmit();
                  }}
                  disabled={loading}
                >
                  {props?.btnOkText ? T(props?.btnOkText) : T("Delete")}
                </FormButton>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
